import { render } from "./Speed.vue?vue&type=template&id=dd36d6cc"
import script from "./Speed.vue?vue&type=script&lang=js"
export * from "./Speed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__